import { fetchFromAPI } from "./apiService";

export const initiateApplication = async (applicationData) => {
  try {
    const response = await fetchFromAPI(
      "/application",
      "POST",
      applicationData,
    );
    return response;
  } catch (error) {
    console.error("Error submitting application:", error);
    throw error;
  }
};

export const updateApplication = async (applicationData) => {
  try {
    const response = await fetchFromAPI(
      "/application",
      "PATCH",
      applicationData,
    );
    return response;
  } catch (error) {
    console.error("Error submitting application:", error);
    throw error;
  }
};

export const getApplication = async (applicationId) => {
  try {
    const response = await fetchFromAPI(
      `/application?applicationId=${applicationId}`,
      "GET",
    );
    return response;
  } catch (error) {
    console.error("Error fetching application:", error);
    throw error;
  }
};

export const verifyArs = async (formData) => {
  try {
    const response = await fetchFromAPI(
      `/application/verify`,
      "POST",
      formData,
    );
    return response;
  } catch (error) {
    console.error("Error verifying ARS:", error);
    throw error;
  }
};

export const getUser = async () => {
  try {
    const response = await fetchFromAPI(`/user`, "GET");
    return response;
  } catch (error) {
    console.error("Error fetching user data:", error);
    throw error;
  }
};

export const getLivenessStatus = async () => {
  try {
    const response = await fetchFromAPI(`/application/liveness/status`, "GET");
    return response;
  } catch (error) {
    console.error("Error fetching liveness status:", error);
    throw error;
  }
};

export const getAddressSearch = async (query) => {
  try {
    const response = await fetchFromAPI(
      `/address/suggest?max=10&q=${encodeURIComponent(query)}`,
      "GET",
    );
    return response;
  } catch (error) {
    console.error("Error fetching address search results:", error);
    throw error;
  }
};

export const getAddressDetails = async (id) => {
  try {
    const response = await fetchFromAPI(
      `/address/details/${encodeURIComponent(id)}`,
      "GET",
    );
    return response;
  } catch (error) {
    console.error("Error fetching address details:", error);
    throw error;
  }
};

export const submitApplication = async (applicationData) => {
  try {
    const response = await fetchFromAPI(
      "/application/submit",
      "POST",
      applicationData,
    );
    return response;
  } catch (error) {
    console.error("Error submitting application:", error);
    throw error;
  }
};

export const getAssertionHistory = async () => {
  try {
    const response = await fetchFromAPI(`/assertions`, "GET");
    return response;
  } catch (error) {
    console.error("Error fetching assertion history:", error);
    throw error;
  }
};

export const getImage = async () => {
  try {
    const response = await fetchFromAPI(`/image`, "GET");
    return response;
  } catch (error) {
    console.error("Error fetching image:", error);
    throw error;
  }
};
